<template>
  <div class="text-left">
    <RejectCommentLayout :comment-text="reject_comment" />
    <v-card class="mt-4 pa-6">
      <v-form ref="form">

        <row-col-select-one-field
          v-model="stay.person"
          data-source="person"
          :label="$t('form.person_stay')"
          :required="true"
        />

        <v-row>
          <col-date-field
            v-model="stay.start_date"
            :label="$t('form.date_start')"
          />
          <col-date-field 
            v-model="stay.end_date"
            :label="$t('form.date_end')"
          />
        </v-row>

        <row-col-radio-horizontal-field
          v-model="stay.type"
          :label="$t('form.stay_type')"
          :options="[
            { text: $t('form.stay_predoc'), value: 'predoc' },
            { text: $t('form.stay_posdoc'), value: 'posdoc' },
            { text: $t('form.stay_other'), value: 'other' }
          ]"
          :required="true"
        />

        <row-col-select-one-field
          v-model="stay.organization"
          data-source="organization"
          :label="$t('form.organization_stay')"
          :required="true"
          :allow-custom-value="true"
        />

        <row-col-text-field
          v-model="stay.responsible"
          :label="$t('form.responsible')"
          :rules="rules.char_max_250"
        />

        <row-col-text-area-field
          v-model="stay.description"
          :label="$t('form.description_stay')"
          :rules="rules.char_max_2000"
        />

        <row-col-select-one-field
          v-model="stay.funder_program"
          data-source="funder_program"
          :label="$t('form.funder_program_stay')"
        />

        <row-col-text-area-field
          v-model="stay.funding_comments"
          :label="$t('form.funding_comments')"
          :rules="rules.char_required_max_2000"
        />

        <UserFormActions
          form_name_text="New stay"
          :form_name="form_name"
          :refForm="$refs.form"
          :saveform_trigger="saveform_trigger"
          :object_type="object_type"
          :data="processData"
          :state="state"
          @change-state="changeState"
          class="text-center mt-6"
        />
      </v-form>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import RejectCommentLayout from "../../layouts/RejectCommentLayout";
import UserFormActions from "../../action_buttons/UserFormActions";
import changeState from "../../../mixins/changeState";
import validationRules from "../../../mixins/validationRules";
import stay_data from "@/mixins/stay_data";
import stay_model from "@/mixins/model_utils/stay_model";
import ColDateField from "../../reusables/ColDateField";
import RowColTextAreaField from "../../reusables/RowColTextAreaField";
import RowColSelectOneField from "../../reusables/RowColSelectOneField";
import RowColTextField from "@/components/reusables/RowColTextField.vue";
import RowColRadioHorizontalField from "@/components/reusables/RowColRadioHorizontalField.vue";

export default {
  mixins: [changeState, validationRules, stay_data, stay_model],
  components: {
    RejectCommentLayout,
    UserFormActions,
    ColDateField,
    RowColTextAreaField,
    RowColSelectOneField,
    RowColTextField,
    RowColRadioHorizontalField
  },

  data: () => ({
    form_name: "newStayForm",
    step: 1,
    tab: null,
    modOp_id: null,
    saveform_trigger: false,
    menu_date: false,
    state: "",
    reject_comment: "",
    object_id: null,
    object_type: "stay",
    people: [],
    organizations: [],
  }),

  created() {
    if (this.updateStayForm) {
      this.getData();
    } else {
      this.load_complete = true;
    }
    axios.get(this.$store.state.endpoint + "/personName")
      .then(response => {
        this.people = response.data;
      })
      .catch(error => {
          console.error(error);
      });
    axios.get(this.$store.state.endpoint + "/organization")
      .then(response => {
        this.organizations = response.data;
      })
      .catch(error => {
          console.error(error);
      });
  },

  computed: {
    updateStayForm() {
      return this.$route.params.id > -1 && !this.$route.meta.update;
    },
    disabledForm() {
      let states = ["VD", "PA", "PV", "PC"];
      return states.includes(this.state);
    },
    processData() {

      let personData = this.people.find(person => person.id === this.stay.person);
      const organizationLabel = this.resolveOrganizationLabel(this.stay.organization);

      let data = {
        title: personData && organizationLabel ? personData.preferred_name.given_name + " " + personData.preferred_name.family_name + " - " + organizationLabel : "",
        object_type: this.object_type,
        form_name: this.form_name,
        object_id: this.object_id,
        data: {
          user: {
            stay: {
              ...this.stay
            }
          }
        }
      };

      return data;
    }
  },

  methods: {
    resolveOrganizationLabel(value) {
      if (!value) {
        return "";
      }
      if (typeof value === "string") {
        return value;
      }
      if (typeof value === "object") {
        if (value.name) {
          return value.name;
        }
        if (value.title) {
          return value.title;
        }
        if (value.id !== undefined && value.id !== null) {
          const match = this.organizations.find(org => org.id === value.id);
          return match ? match.name : "";
        }
        return "";
      }
      const match = this.organizations.find(org => org.id === value);
      return match ? match.name : "";
    },
    getData() {
      let path =
        this.$store.state.endpoint +
        "/user/moderatedOperations/stay/" +
        this.$route.params.id;
      axios
        .get(path)
        .then(response => {
          this.modOp_id = response.data.id;
          this.stay = response.data.data.user.stay;
          this.state = response.data.state;
          this.reject_comment = response.data.reject_comment;
          this.stay.id = response.data.object_id;
        })
        .finally(() => (this.load_complete = true))
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
